import React from 'react';
import ReduxPromiseListener from 'react-redux-promise-listener';
import { Form } from 'react-final-form';
import { promiseListener } from '../../../store';

interface ActionType {
  id: string;
  start: string;
  success: string;
  error: string;
}

const withForm =
  (actionType: ActionType, listenerProps: any = {}, formProps: any = {}) => 
  (Component: React.ComponentType<any>) => 
  (props: any) =>
    (
      <ReduxPromiseListener
        listener={promiseListener}
        start={actionType.start}
        resolve={actionType.success}
        {...listenerProps}
      >
        {(onSubmit) => (
          <Form
            onSubmit={onSubmit}
            render={(form) => <Component formProps={form} {...props} />}
            {...formProps}
          />
        )}
      </ReduxPromiseListener>
    );

export default withForm;
